import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { AXIS, GRID, TOOLTIP_STYLE } from './ChartCard.js';

interface Row {
  label: string;
  diamond: number;
  house: number;
  comp: number;
}

/** Diamond / House / Comp stacked bars per period (chart #4). */
export function DiamondMixChart({ data }: { data: Row[] }) {
  return (
    <ResponsiveContainer width="100%" height={280}>
      <BarChart data={data} margin={{ top: 8, right: 12, bottom: 8, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={GRID} />
        <XAxis dataKey="label" tick={AXIS} />
        <YAxis tick={AXIS} />
        <Tooltip contentStyle={TOOLTIP_STYLE} />
        <Legend wrapperStyle={{ fontSize: 12 }} />
        <Bar dataKey="diamond" name="Diamond" stackId="a" fill="#3b82f6" />
        <Bar dataKey="house" name="House" stackId="a" fill="#22c55e" />
        <Bar dataKey="comp" name="Comp" stackId="a" fill="#f59e0b" />
      </BarChart>
    </ResponsiveContainer>
  );
}
